import { getInternalNumber, getNumberDecimal } from "csi/utility/numberUtility";
import React, { forwardRef, useState } from "react";
import TextField, { TextFieldProps } from "./TextField";

interface LocaleNumberFieldProps extends TextFieldProps {
	value?: string | number;

	defaultValue?: string | number;
}

const LocaleNumberField: React.FC<LocaleNumberFieldProps> = forwardRef((props, ref) => {
	const {
		onChange,
		value: propValue,
		defaultValue: propDefaultValue,
		...otherProps
	} = props;

	const [value, setValue] = useState(propValue || propDefaultValue || "");
  	const decimalSeparator = getNumberDecimal();

	const handleChange = (event) => {
		const inputValue = event.target.value;

		// Allow only digits and the correct decimal separator
		const regex = new RegExp(`^[0-9${decimalSeparator}]*$`);

		if (regex.test(inputValue) && inputValue !== value) {
			setValue(inputValue);

			if (onChange) {
				const transformedValue = getInternalNumber(inputValue);
				const eventCopy = {
					...event,
					target: { ...event.target, value: transformedValue },
				};
				onChange(eventCopy);
			}
		}
	};
	
	return (
		<TextField
			{...otherProps}
			onChange={handleChange}
			ref={ref}
			type="text"
			value={value}
		/>
	);
});

export default LocaleNumberField;
